<template>
    <b-container style="padding-top: 10px; padding-bottom: 10px">
        <b-row>
            <b-col class="intro col-8 main">
                <b-row class="row">
                    <b-col class="col-12">
                        <h2> Hi, I'm Kyle. </h2>
                        <p> Welcome to my portfolio page! I'm using this as a place to practice and work on things that I
                            enjoy but don't get paid for. After all, the best way to learn is by doing...
                        </p>
                        <p>
                            I'm an avid traveler, photographer, and explorer. If I'm not exploring a new place, I'll explore new technologies
                            (see this site) or skills. I also enjoy potentially dangerous sports like
                            snowboarding, rock climbing, ice hockey, and grocery shopping when I'm hungry.
                        </p>
                        <p>
                            This site was created with Vue.js, Bootstrap and janky CSS and is hosted in Firebase.
                            Most of my projects are made with R and Python.
                            That back-end is hosted with a flask server on Google App engine because I can't figure out how to run template loaders in Vue.
                            My photos are edited in Lightroom and shot on a D7200. Sometimes I'll make my own icons in Illustrator.
                        </p>
                    </b-col>
                </b-row>
                <b-row align-v end>
                    <b-col>
                        <b-button class="btn-img" variant="outline-danger" @click="$router.push({ name: 'Blog' })">Read my Blog</b-button>
                        <b-button class="btn-img" variant="outline-primary" @click="$router.push({ name: 'Projects' })">Check out Projects</b-button>
                        <b-button class="btn-img" variant="outline-success" @click="$router.push({ name: 'Photos' })">Check out Photos</b-button>
                    </b-col>
                </b-row>
            </b-col>
            <b-col class="intro">
                <b-img class="img-fluid rounded float-right" :src="require('../assets/intro.png')"></b-img>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>


export default {};
</script>

<style>
    .intro {
    }
    .main {
        padding:10px;
        border-style:solid;
        border-width:1px;
        border-radius:5px
    }
    .btn-img {
        margin:5px;
    }
</style>
